import getSearchUsers from "./admin/userManagement/getSearchUsers";
import forgotPassword from "./login/forgotPassword";
import isPasswordResetRequired from "./login/isPasswordResetRequired";
import IsUserActive from "./login/isUserActive";
import IsUserExist from "./login/isUserExists";
import lastLogin from "./login/lastLogin";
import login from "./login/login";
import login2 from "./login/login2";
import preLogin from "./login/preLogin";
import deleteShotClass from "./manage/deleteShotclass";
import getManageTranscription from "./manage/getManageTranscription";
import getMyDrafts from "./manage/getMyDrafts";
import getPublishedByMe from "./manage/getPublishedByMe";
import getPublishedByOthers from "./manage/getPublishedByOthers";
import getUserVisualReport from "./reports/graphicalReport/getUserVisualReport";
import getUserDistributionSummary from "./reports/graphicalReport/getUserDistributionSummary";
import getClassDistributionSummary from "./reports/graphicalReport/getClassDistributionSummary";
import getClassVisualReport from "./reports/graphicalReport/getClassVisualReport";
import getAssignedClass from "./reports/graphicalReport/reportFilter/getAssignedClass";
import getQuizImages from "./manage/getQuizImages";
import getManageTrainingTypes from "./manage/getTrainingTypes";
import getAllPolls from "./social/pollManagement/getAllPolls";
import getMyPolls from "./social/pollManagement/getMyPolls";
import getMyProfile from "./profile/getMyProfile";
import updateMyProfile from "./profile/updateMyProfile";
import resetPassword from "./profile/resetPassword";
import addTrainingType from "./manage/addTrainingType";
import deleteTrainingType from "./manage/deleteTrainingType";
import postCSVBulkUpload from "./manage/postCSVBulkUpload";
import postCSVURLBulkUpload from "./manage/postCSVURLBulkUpload";
import getCSVLastUploadDate from "./manage/getCSVLastUploadDate";
import deleteQuizImages from "./manage/deleteQuizImages";
import getExistingQuizImages from "./manage/getExistingQuizImages";
import postMultiQuizImages from "./manage/postMultiQuizImages";
import getTenantUsers from "./reports/graphicalReport/reportFilter/getTenantUsers";
import getTrainingTypes from "./manage/getTrainingTypes";
import getFilterClassDistributionSummary from "./reports/graphicalReport/reportFilter/getFilterClassDistributionSummary";
import getFilterClassVisualReport from "./reports/graphicalReport/reportFilter/getFilterClassVisualReport";
import getFilterUserDistributionSummary from "./reports/graphicalReport/reportFilter/getFilterUserDistributionSummary";
import getFilterUserVisualReport from "./reports/graphicalReport/reportFilter/getFilterUserVisualReport";
import getAllVariantLanguages from "./manage/getAllVariantLanguages";
import contactUs from "./profile/contactUs";
import getUserGroup from "./reports/graphicalReport/reportFilter/getUserGroup";
import getClassName from "./reports/graphicalReport/reportFilter/getClassName";
import getUserDistributionReport from "./reports/tabularReport/getUserDistributionReport";
import getClassDistributionReport from "./reports/tabularReport/getClassDistributionReport";
import getYoutubeVideos from "./manage/getYoutubeVideos";
import getOnlineCourses from "./manage/getOnlineCourses";
import isNameExists from "./manage/isNameExists";
import getSearchClassTags from "./manage/getSearchClassTags";
import getClassDetailsById from "./manage/getClassDetailsById";
import postImage from "./social/pollManagement/postImage";
import postPoll from "./social/pollManagement/postPoll";
import getPollById from "./social/pollManagement/getPollById";
import isPollExist from "./social/pollManagement/isPollExist";
import editPoll from "./social/pollManagement/editPoll";
import deletePoll from "./social/pollManagement/deletePoll";
import lockPoll from "./social/pollManagement/lockPoll";
import unlockPoll from "./social/pollManagement/unlockPoll";
import eventGetMyDrafts from "./events/eventGetMyDrafts";
import eventGetPublishedByMe from "./events/eventGetPublishedByMe";
import eventGetPublishedByOthers from "./events/eventGetPublishedByOthers";
import deleteEventShotClass from "./events/deleteEventShotClass";
import postLiveQuizEvent from "./events/postLiveQuizEvent";
import getClassByTagsLiveTraining from "./events/getClassByTagsLiveTraining";
import getClassByTagsVirtualTraining from "./events/getClassByTagsVirtualTraining";
import copyPoll from "./social/pollManagement/copyPoll";
import pollResult from "./social/pollManagement/pollResult";
import createShotclass from "./manage/createShotclass";
import uploadPptShotClass from "./manage/uploadPptShotClass";
import getStoredMediaInfo from "./manage/getStoredMediaInfo";
import setMetaDataForVideo from "./manage/setMetaDataForVideo";
import uploadVideoChunk from "./manage/uploadVideoChunk";
import uploadPdfShotClass from "./manage/uploadPdfShotClass";
import uploadScormOrHtmlShotClass from "./manage/uploadScormShotClass";
import PollResultByGroupId from "./social/pollManagement/pollResultByGroupId";
import getUserGroups from "./manage/getUserGroups";
import transcribeShotclass from "./manage/transcribeShotclass";
import getUserShotClassReport from "./reports/tabularReport/getUserShotClassReport";
import getCountryList from "./reports/tabularReport/getCountryList";
import getStateList from "./reports/tabularReport/getStateList";
import getWorkOfficeList from "./reports/tabularReport/getWorkOfficeList";
import getCityList from "./reports/tabularReport/getCityList";
import getProductCategoryList from "./reports/tabularReport/getProductCategoryList";
import getUserClassCompletionReport from "./reports/tabularReport/getUserClassCompletionAdvanceReport";
import getShotClassUserReport from "./reports/tabularReport/getShotClassUserReport";
import getSearchClassName from "./reports/tabularReport/getSearchClassName";
import sendRemainder from "./reports/tabularReport/sendRemainder";
import getSurveyReport from "./reports/surveyReport/getSurveyReport";
import getClassesWithSurvey from "./reports/surveyReport/getClassesWithSurvery";
import updateShotclass from "./manage/updateShotclass";
import copyShotclass from "./manage/copyShotclass";
import getVideoMediaToken from "./manage/getVideoMediaToken";
import getForumTopics from "./social/forumArea/getForumTopics";
import getTenantPollUsers from "./social/pollManagement/getTenantPollUsers";
import getPollUserGroup from "./social/pollManagement/getPollUserGroup";
import getSearchPollUser from "./social/pollManagement/getSearchPollUser";
import getSearchPollGroup from "./social/pollManagement/getSearchPollGroup";
import distributePoll from "./social/pollManagement/distributePoll";
import getSemanticSectionsById from "./manage/getSemanticSectionsById";
import updateTranscribeShotclass from "./manage/updateTranscribeShotclass";
import getSemanticClassById from "./manage/getSemanticClassById";
import getSlideShares from "./manage/getSlideShares";
import isTrainingTypeExists from "./manage/isTrainingTypeExists";
import uploadSlideShare from "./manage/uploadSlideShare";
import getForumThreads from "./social/forumArea/getForumThreads";
import getForumComments from "./social/forumArea/getForumComments";
import getUserByName from "./events/getUserByName";
import createForumTopic from "./social/forumArea/createForumTopic";
import editForumTopic from "./social/forumArea/editForumTopic";
import updateForumTopic from "./social/forumArea/updateForumTopic";
import createForumThread from "./social/forumArea/createForumThread";
import updateForumThread from "./social/forumArea/updateForumThread";
import createForumComment from "./social/forumArea/createForumComment";
import getSubmissionsData from "./social/moderateContributions/getSubmissionsData";
import getMyModerationData from "./social/moderateContributions/getMyModerationData";
import getLockByOthersData from "./social/moderateContributions/getLockByOthersData";
import getRejectedData from "./social/moderateContributions/getRejectedData";
import getPublishedData from "./social/moderateContributions/getPublishedData";
import getPublishedByOthersData from "./social/moderateContributions/getPublishedByOthersData";
import getShotclassSourcingClassDetailsById from "./social/moderateContributions/getShotclassSourcingClassDetailsById";
import getModeratorContributorComments from "./social/moderateContributions/getModeratorContributorComments";
import postContributorModeratorComments from "./social/moderateContributions/postContributorModeratorComments";
import lockContributorShotClass from "./social/moderateContributions/lockContributorShotClass";
import unLockContributorShotClass from "./social/moderateContributions/unLockContributorShotClass";
import rejectShotClass from "./social/moderateContributions/rejectShotClass";
import updateShotClassSourcing from "./social/moderateContributions/updateShotClassSourcing";
import getPasswordExpiryPeriod from "./admin/organizationSettings/getPasswordExpiryPeriod";
import setPasswordExpiryPeriod from "./admin/organizationSettings/setPasswordExpiryPeriod";
import getUserEmailDetails from "./admin/organizationSettings/getUserEmailDetails";
import addUserEmailDetails from "./admin/organizationSettings/addUserEmailDetails";
import getLocationListCSV from "./admin/organizationSettings/getLocationListCSV";
import getUserDepartmentListCSV from "./admin/organizationSettings/getUserDepartmentListCSV";
import getUsersStatus from "./admin/userManagement/getUsersStatus";
import unlockUserAccount from "./admin/userManagement/unlockUserAccount";
import getRolesAndPernissions from "./admin/rolesAndPermission/getRolesAndPernissions";
import postRoleMenuMapping from "./admin/rolesAndPermission/postRoleMenuMapping";
import toggleUserStatus from "./admin/userManagement/toggleUserStatus";
import checkRoleName from "./admin/rolesAndPermission/checkRoleName";
import createRole from "./admin/rolesAndPermission/createRole";
import getGroupManagementUserGroup from "./admin/groupManagement/getUserGroup";
import checkUniqueUserGroupName from "./admin/groupManagement/checkUniqueUserGroupName";
import postUserGroup from "./admin/groupManagement/postUserGroup";
import getAllRoles from "./admin/userManagement/getAllRoles";
import deleteGroup from "./admin/groupManagement/deleteGroup";
import postUserProfile from "./admin/userManagement/postUserProfile";
import getQuizReport from "./reports/quizReport/getQuizReport";
import getAccessReport from "./reports/accessReport/getAccessReport";
import getClassWiseUsageDeatils from "./reports/adoptionReport/getClassWiseUsageDetails";
import getMobileAppInstallationCount from "./reports/adoptionReport/getMobileAppInstallationCount";
import getNoOfUserAccessedShotclassApplication from "./reports/adoptionReport/getNoOfUserAccessedShotclassApplication";
import getNoOfUserAccessedShotclassess from "./reports/adoptionReport/getNoOfUserAccessedShotclasses";
import getShotclassCompletionTrend from "./reports/adoptionReport/getShotclassCompletionTrend";
import getTotalActiveUser from "./reports/adoptionReport/getTotalActiveUsers";
import getUserGroupAccessDetails from "./reports/adoptionReport/getUserGroupAccessDetails";
import getUserGroupClassUsageDetails from "./reports/adoptionReport/getUserGroupClassUsageDetails";
import getMobileInstallationTrend from "./reports/adoptionReport/getMobileInstallationtTrend";
import getDrillDownQuizReport from "./reports/quizReport/getDrillDownQuizReport";
import getApplicationAccessUserDetails from "./reports/accessReport/getApplicationAccessUserDetails";
import getUserGroupMembers from "./admin/groupManagement/getUserGroupMembers";
import getAllRolesAssignUsersToROles from "./admin/assignUserToRoles/getAllRoles";
import getUserRoles from "./admin/assignUserToRoles/getUserRoles";
import { postAssignUserToRoles } from "./admin/assignUserToRoles/postAssignUserToRoles";
import getUserByNameInGroupManagement from "./admin/groupManagement/getUserByName";
import postMember from "./admin/groupManagement/postMember";
import deleteMember from "./admin/groupManagement/deleteMember";
import getUserProfile from "./admin/userManagement/getUserProfile";
import getUserGroupsByUserId from "./admin/userManagement/getUserGroupsByUserId";
import putUserProfile from "./admin/userManagement/putUserProfile";
import isLoginIdExists from "./admin/userManagement/isLoginIdExists";
import getManageCertificates from "./admin/certificateManagement/getManageCertificates";
import deleteCertificate from "./admin/certificateManagement/deleteCertificate";
import uploadCertificate from "./admin/certificateManagement/uploadCertificate";
import postNewCertificate from "./admin/certificateManagement/postNewCertificate";
import postEditCertificate from "./admin/certificateManagement/postEditCertificate";
import getSubgroupById from "./admin/groupManagement/getSubgroupById";
import getSubgroup from "./admin/groupManagement/getSubgroup";
import setSubgroup from "./admin/groupManagement/setSubgroup";
import deleteSubgroup from "./admin/groupManagement/deleteSubgroup";
import getSearchClass from "./admin/groupManagement/getSearchClass";
import { sendToQueue } from "./admin/emailTrigger/sendToQueue";
import getUserGroupsManadatedShotclasses from "./admin/groupManagement/getUserGroupsManadatedShotclasses";
import deleteMandatedClasses from "./admin/groupManagement/deleteMandatedClasses";
import getAllNotifications from "./admin/engagementCenter/getAllNotifications";
import triggerNotification from "./admin/engagementCenter/triggerNotification";
import deleteNotification from "./admin/engagementCenter/deleteNotification";
import getAllNotificationHistory from "./admin/engagementCenter/getAllNotificationHistory";
import deleteMandatedProgram from "./admin/groupManagement/deleteMandatedProgram";
import mandatedClasses from "./admin/groupManagement/mandateClasses";
import mandateProgram from "./admin/groupManagement/mandateProgram";
import getSearchPrograms from "./admin/groupManagement/getSearchPrograms";
import getClassAndCollectionByProgramId from "./admin/groupManagement/getClassAndCollectionByProgramId";
import getAllProgramsCount from "./distribute/getAllProgramsCount";
import getShotClasses from "./distribute/getShotclasses";
import getUserClassCompletionGraphReport from "./reports/tabularReport/getUserClassCompletionGraphReport";
import getUserClassCompletionAdvanceReport from "./reports/tabularReport/getUserClassCompletionAdvanceReport";
import getUserResponseToQuestion from "./reports/quizReport/getUserResponseToQuestions";
import getAllAssignedQueries from "./admin/myQueries/getAllAssignedQueries";
import deleteQuery from "./admin/myQueries/deleteQuery";
import putQuery from "./admin/myQueries/putQuery";
import putUnreadCount from "./admin/myQueries/putUnreadCount";
import putIsRead from "./admin/myQueries/putIsRead";
import getAllAssignedSupportQueries from "./admin/myQueries/getAllAssignedSupportQueries";
import getDistributionHistory from "./distribute/getDistributionHistory";
import getSearchShotclasses from "./distribute/getSearchShotclasses";
import getUserClassAssignment from "./distribute/getUserClassAssignment";
import putAssignedClasses from "./distribute/putAssignedClasses";
import archiveClasses from "./distribute/archiveClasses";
import distributeGetUserByName from "./distribute/getUserByName";
import getNotificationById from "./admin/engagementCenter/getNotificationById";
import getNotificationMode from "./admin/engagementCenter/getNotificationMode";
import getNotificationTemplate from "./admin/engagementCenter/getNotificationTemplate";
import getNotificationType from "./admin/engagementCenter/getNotificationType";
import getNotificationEvent from "./admin/engagementCenter/getNotificationEvent";
import getNotificationEventValues from "./admin/engagementCenter/getNotificationEventValues";
import getLandingPages from "./admin/engagementCenter/getLandingPages";
import updateNotification from "./admin/engagementCenter/updateNotification";
import getNotificationFrequency from "./admin/engagementCenter/getNotificationFrequency";
import getNotificationPlaceholders from "./admin/engagementCenter/getNotificationPlaceholders";
import getPlaceholderEventValues from "./admin/engagementCenter/getPlaceholderEventValues";
import getPlaceHolderEvents from "./admin/engagementCenter/getPlaceHolderEvents";
import getProgramDistributionHistory from "./distribute/getProgramDistributionHistory";
import deleteProgram from "./distribute/deleteProgram";
import deleteCollection from "./distribute/deleteCollection";
import getTrendingClasses from "./dashboard/getTrendingClasses";
import distributeClasses from "./distribute/distributeClasses";
import getDefaultShotClassInformation from "./reports/analyticalReport/getDefaultShotClassInformation";
import getSearchUserGroup from "./reports/tabularReport/getSearchUserGroup";
import getWorkOrOfficeLocationList from "./distribute/getWorkOrOfficeLocationList";
import getStoreListByStoreId from "./distribute/getStoreListByStoreId";
import getStoreListByCountryId from "./distribute/getStoreListByCountryId";
import aadAdminConsent from "./login/aadAdminConsent";
import getTenantDetails from "./login/getTenantDetails";
import postCollection from "./distribute/postCollection";
import getAllGroupTopics from "./organize/getAllGroupTopics";
import getAllTopics from "./organize/getAllTopics";
import getRecentlyAddedPrograms from "./organize/getRecentlyAddedPrograms";
import getRecentlyAddedProgramsSeriesMgmt from "./organize/getRecentlyAddedProgramsSeriesMgmt";
import getAllProgramsCountOrganizeWithoutCondition from "./organize/getAllProgramsCountOrganizeWithoutCondition";
// import postImage from "./organize/postImage";
import addGroupTopic from "./organize/addGroupTopic";
import getSearchTopicTags from "./organize/getSearchTopicTags";
import isTopicExists from "./organize/isTopicExists";
import addTopic from "./organize/addTopic";
import getTopicDetailsByProgramID from "./organize/getTopicDetailsByProgramID";
import updateProgram from "./organize/updateProgram";
import isNameExist from "./organize/isNameExit";
import getSearchProgramTags from "./organize/getSearchProgramTags";
import postSeriesProgram from "./organize/postSeriesProgram";
import getCertificate from "./distribute/getCertificate";
import postCertificate from "./distribute/postCertificate";
import getCertificateByProgramId from "./distribute/getCertificateByProgramId";
import getTopicByID from "./organize/getTopicByID";
import deleteTopicByID from "./organize/deleteTopicByID";
import updateTopic from "./organize/updateTopic";
import getGroupTopicByID from "./organize/getGroupTopicByID";
import updateGroupTopic from "./organize/updateGroupTopic";
import getHeaderUserProfile from "./profile/getHeaderUserProfile";
import getUserGroupByUserId from "./profile/getUserGroupByUserId";
import putMyProfile from "./profile/putMyProfile";
import getUsersListCSV from "./admin/userManagement/getUsersListCSV";
import deleteQuizQuestion from "./manage/deleteQuizQuestion";
import searchSeriesProgram from "./organize/searchSeriesProgram";
import getNotificationHistoryCSV from "./admin/engagementCenter/getNotificationHistoryCSV";
import getClassByStatusWithCondition from "./distribute/getClassByStatusWithCondition";
import getAllPublishedByMeClassnames from "./distribute/getAllPublishedByMeClassnames";
import userCancelledVideoUpload from "./manage/userCancelledVideoUpload";
import addToQueueVideo from "./manage/addToQueueVideo";
import getComprehensiveReportCSV from "./reports/tabularReport/getComprehensiveReportCSV";
import getTabularReportCSV from "./reports/tabularReport/getTabularReportCSV";
import getAccessReportCSV from "./reports/accessReport/getAccessReportCSV";
import getAccessDetailedReportCSV from "./reports/accessReport/getAccessDetailedReportCSV";
import updateDorumComment from "./social/forumArea/updateDorumComment";
import getUserRoleMenu from "./common/getUserRoleMenu";
import getUserRolesMenu from "./userRoles/getUserRoleMenu";
import getTenantProfile from "./tenantDetail/getTenantProfile";
import editCertificate from "./organize/editCertificate";
import getTenantPermissionInfo from "./admin/rolesAndPermission/getTenantPermissionInfo";
import getAADApplicationReport from "./reports/accessReport/getAADApplicationReport";
import getAADUserAccessDetailsReport from "./reports/accessReport/getAADUserAccessDetailsReport";
import IsDomainNameExists from "./admin/organizationSettings/isDomainNameExists";
import addDomainName from "./admin/organizationSettings/addDomainName";
import deleteDomainName from "../utils/mainTabs/admin/organizationSettings/deleteDomainName";
import updateDomainName from "./admin/organizationSettings/updateDomainName";
import getDomainNames from "./admin/userManagement/getDomainName";
import latestImportStatus from "./admin/organizationSettings/latestImportStatus";
import getAADUserAccessDetailReportCSV from "./reports/accessReport/getAADUserAccessDetailReportCSV";
import pollDownloadResult from "./social/pollManagement/pollDownloadResult";
import getAADApplicationReportCSV from "./reports/accessReport/getAADApplicationReportCSV";
import getUserReport from "./reports/tabularReport/getUserReport";
import deleteUserToken from "./login/deleteUserToken";
import revokeTokenOnLogout from "./login/revokeTokenOnLogout";
import uploadCalanderFile from "./manage/uploadCalanderFile";
const apis = {
  common: {
    getUserRoleMenu: getUserRoleMenu,
    getTenantPermissionInfo: getTenantPermissionInfo,
  },
  login: {
    preLogin: preLogin,
    getTenantDetails: getTenantDetails,
    login: login,
    login2: login2,
    lastLogin: lastLogin,
    IsUserExist: IsUserExist,
    IsUserActive: IsUserActive,
    isPasswordResetRequired: isPasswordResetRequired,
    forgotPassword: forgotPassword,
    aadAdminConsent: aadAdminConsent,
    deleteUserToken: deleteUserToken,
    revokeTokenOnLogout: revokeTokenOnLogout,
  },
  dashboard: {
    getTrendingClasses: getTrendingClasses,
  },
  userRoles: {
    getUserRoleMenu: getUserRolesMenu,
  },
  tenantProfile: {
    getTenantProfile: getTenantProfile,
  },
  admin: {
    organizationSettings: {
      getPasswordExpiryPeriod: getPasswordExpiryPeriod,
      setPasswordExpiryPeriod: setPasswordExpiryPeriod,
      getUserEmailDetails: getUserEmailDetails,
      addUserEmailDetails: addUserEmailDetails,
      IsDomainNameExists: IsDomainNameExists,
      addDomainName: addDomainName,
      deleteDomainName: deleteDomainName,
      updateDomainName: updateDomainName,
      getDomainNames: getDomainNames,
      latestImportStatus: latestImportStatus,
      getLocationListCSV: getLocationListCSV,
      getUserDepartmentListCSV: getUserDepartmentListCSV,
    },
    userManagement: {
      getUsersListCSV: getUsersListCSV,
      getSearchUsers: getSearchUsers,
      getUsersStatus: getUsersStatus,
      isLoginIdExists: isLoginIdExists,
      unlockUserAccount: unlockUserAccount,
      toggleUserStatus: toggleUserStatus,
      getCountryList: getCountryList,
      getStateList: getStateList,
      getCityList: getCityList,
      getWorkOfficeList: getWorkOfficeList,
      getProductCategoryList: getProductCategoryList,
      getUserGroups: getUserGroups,
      getAllRoles: getAllRoles,
      postUserProfile: postUserProfile,
      getUserProfile: getUserProfile,
      getUserGroupsByUserId: getUserGroupsByUserId,
      putUserProfile: putUserProfile,
    },
    rolesAndPermissions: {
      getRolesAndPernissions: getRolesAndPernissions,
      postRoleMenuMapping: postRoleMenuMapping,
      checkRoleName: checkRoleName,
      createRole: createRole,
    },
    groupManagement: {
      getUserGroup: getGroupManagementUserGroup,
      checkUniqueUserGroupName: checkUniqueUserGroupName,
      postUserGroup: postUserGroup,
      deleteGroup: deleteGroup,
      getUserGroupMembers: getUserGroupMembers,
      getUserByName: getUserByNameInGroupManagement,
      postMember: postMember,
      deleteMember: deleteMember,
      getSubgroupById: getSubgroupById,
      getSubgroup: getSubgroup,
      setSubgroup: setSubgroup,
      deleteSubgroup: deleteSubgroup,
      getSearchClass: getSearchClass,
      getUserGroupsManadatedShotclasses: getUserGroupsManadatedShotclasses,
      deleteMandatedClasses: deleteMandatedClasses,
      deleteMandatedProgram: deleteMandatedProgram,
      mandatedClasses: mandatedClasses,
      mandateProgram: mandateProgram,
      getSearchPrograms: getSearchPrograms,
      getClassAndCollectionByProgramId: getClassAndCollectionByProgramId,
    },
    certificateManagement: {
      getManageCertificates: getManageCertificates,
      deleteCertificate: deleteCertificate,
      uploadCertificate: uploadCertificate,
      postNewCertificate: postNewCertificate,
      postEditCertificate: postEditCertificate,
    },
    assignUsersToRoles: {
      getAllRolesAssignUsersToROles: getAllRolesAssignUsersToROles,
      getUserRoles: getUserRoles,
      postAssignUserToRoles: postAssignUserToRoles,
    },
    emailTrigger: {
      sendToQueue: sendToQueue,
    },
    engagementCenter: {
      getAllNotifications: getAllNotifications,
      triggerNotification: triggerNotification,
      deleteNotification: deleteNotification,
      getAllNotificationHistory: getAllNotificationHistory,
      getNotificationById: getNotificationById,
      getNotificationMode: getNotificationMode,
      getNotificationTemplate: getNotificationTemplate,
      getNotificationType: getNotificationType,
      getNotificationFrequency: getNotificationFrequency,
      getNotificationPlaceholders: getNotificationPlaceholders,
      getNotificationEvent: getNotificationEvent,
      getNotificationEventValues: getNotificationEventValues,
      getPlaceHolderEvents: getPlaceHolderEvents,
      getPlaceholderEventValues: getPlaceholderEventValues,
      getLandingPages: getLandingPages,
      updateNotification: updateNotification,
      getNotificationHistoryCSV: getNotificationHistoryCSV,
    },
    myQueries: {
      getAllAssignedQueries: getAllAssignedQueries,
      getAllAssignedSupportQueries: getAllAssignedSupportQueries,
      deleteQuery: deleteQuery,
      putQuery: putQuery,
      putUnreadCount: putUnreadCount,
      putIsRead: putIsRead,
    },
  },
  manage: {
    getMyDrafts: getMyDrafts,
    getPublishedByMe: getPublishedByMe,
    getPublishedByOthers: getPublishedByOthers,
    getManageTranscription: getManageTranscription,
    transcribeShotclass: transcribeShotclass,
    getTrainingTypes: getManageTrainingTypes,
    isTrainingTypeExists: isTrainingTypeExists,
    addTrainingType: addTrainingType,
    deleteTrainingType: deleteTrainingType,
    getQuizImages: getQuizImages,
    getExistingQuizImages: getExistingQuizImages,
    postMultiQuizImages: postMultiQuizImages,
    deleteQuizImages: deleteQuizImages,
    deleteShotClass: deleteShotClass,
    postCSVBulkUpload: postCSVBulkUpload,
    postCSVURLBulkUpload: postCSVURLBulkUpload,
    getCSVLastUploadDate: getCSVLastUploadDate,
    isNameExists: isNameExists,
    getSearchClassTags: getSearchClassTags,
    getAllVariantLanguages: getAllVariantLanguages,
    getUserGroups: getUserGroups,
    getYoutubeVideos: getYoutubeVideos,
    getOnlineCourses: getOnlineCourses,
    getSlideShares: getSlideShares,
    getClassDetailsById: getClassDetailsById,
    createShotclass: createShotclass,
    uploadPptShotClass: uploadPptShotClass,
    uploadPdfShotClass: uploadPdfShotClass,
    uploadSlideShare: uploadSlideShare,
    getStoredMediaInfo: getStoredMediaInfo,
    setMetaDataForVideo: setMetaDataForVideo,
    uploadVideoChunk: uploadVideoChunk,
    addToQueueVideo: addToQueueVideo,
    userCancelledVideoUpload: userCancelledVideoUpload,
    uploadScormOrHtmlShotClass: uploadScormOrHtmlShotClass,
    updateShotclass: updateShotclass,
    deleteQuizQuestion: deleteQuizQuestion,
    copyShotclass: copyShotclass,
    getVideoMediaToken: getVideoMediaToken,
    getSemanticSectionsById: getSemanticSectionsById,
    getSemanticClassById: getSemanticClassById,
    updateTranscribeShotclass: updateTranscribeShotclass,
    uploadCalanderFile: uploadCalanderFile,
  },
  events: {
    eventGetMyDrafts: eventGetMyDrafts,
    eventGetPublishedByMe: eventGetPublishedByMe,
    eventGetPublishedByOthers: eventGetPublishedByOthers,
    deleteEventShotClass: deleteEventShotClass,
    getUserByName: getUserByName,
    postLiveQuizEvent: postLiveQuizEvent,
    getClassByTagsLiveTraining: getClassByTagsLiveTraining,
    getClassByTagsVirtualTraining: getClassByTagsVirtualTraining,
  },
  distribute: {
    getAllProgramsCount: getAllProgramsCount,
    getShotClasses: getShotClasses,
    getDistributionHistory: getDistributionHistory,
    getSearchShotclasses: getSearchShotclasses,
    getUserClassAssignment: getUserClassAssignment,
    putAssignedClasses: putAssignedClasses,
    archiveClasses: archiveClasses,
    getUserByName: distributeGetUserByName,
    getProgramDistributionHistory: getProgramDistributionHistory,
    deleteProgram: deleteProgram,
    deleteCollection: deleteCollection,
    distributeClasses: distributeClasses,
    getWorkOrOfficeLocationList: getWorkOrOfficeLocationList,
    getStoreListByStoreId: getStoreListByStoreId,
    getStoreListByCountryId: getStoreListByCountryId,
    postCollection: postCollection,
    getCertificate: getCertificate,
    postCertificate: postCertificate,
    getCertificateByProgramId: getCertificateByProgramId,
    getClassByStatusWithCondition: getClassByStatusWithCondition,
    getAllPublishedByMeClassnames: getAllPublishedByMeClassnames,
  },
  organize: {
    getAllGroupTopics: getAllGroupTopics,
    getAllTopics: getAllTopics,
    getRecentlyAddedPrograms: getRecentlyAddedPrograms,
    getAllProgramsCountOrganizeWithoutCondition:
      getAllProgramsCountOrganizeWithoutCondition,
    postImage: postImage,
    addGroupTopic: addGroupTopic,
    getSearchTopicTags: getSearchTopicTags,
    isTopicExists: isTopicExists,
    addTopic: addTopic,
    getTopicDetailsByProgramID: getTopicDetailsByProgramID,
    updateProgram: updateProgram,
    getRecentlyAddedProgramsSeriesMgmt: getRecentlyAddedProgramsSeriesMgmt,
    isNameExist: isNameExist,
    getSearchProgramTags: getSearchProgramTags,
    postSeriesProgram: postSeriesProgram,
    getTopicByID: getTopicByID,
    deleteTopicByID: deleteTopicByID,
    updateTopic: updateTopic,
    getGroupTopicByID: getGroupTopicByID,
    updateGroupTopic: updateGroupTopic,
    searchSeriesProgram: searchSeriesProgram,
    editCertificate: editCertificate,
  },
  profile: {
    getMyProfile: getMyProfile,
    updateMyProfile: updateMyProfile,
    resetPassword: resetPassword,
    contactUs: contactUs,
    getHeaderUserProfile: getHeaderUserProfile,
    getUserGroupByUserId: getUserGroupByUserId,
    putMyProfile: putMyProfile,
  },
  reports: {
    common: {
      getTenantUsers: getTenantUsers,
      getTrainingTypes: getTrainingTypes,
      getUserGroup: getUserGroup,
      getClassName: getClassName,
    },
    graphicalReports: {
      getUserVisualReport: getUserVisualReport,
      getUserDistributionSummary: getUserDistributionSummary,
      getClassDistributionSummary: getClassDistributionSummary,
      getClassVisualReport: getClassVisualReport,
      getFilterUserDistributionSummary: getFilterUserDistributionSummary,
      getFilterUserVisualReport: getFilterUserVisualReport,
      getFilterClassDistributionSummary: getFilterClassDistributionSummary,
      getFilterClassVisualReport: getFilterClassVisualReport,
      getAssignedClass: getAssignedClass,
    },
    tabularReport: {
      getUserDistributionReport: getUserDistributionReport,
      getClassDistributionReport: getClassDistributionReport,
      getUserShotClassReport: getUserShotClassReport,
      getShotClassUserReport: getShotClassUserReport,
      getCountryList: getCountryList,
      getStateList: getStateList,
      getCityList: getCityList,
      getWorkOfficeList: getWorkOfficeList,
      getProductCategoryList: getProductCategoryList,
      getUserClassCompletionReport: getUserClassCompletionReport,
      getSearchClassName: getSearchClassName,
      sendRemainder: sendRemainder,
      getUserClassCompletionAdvanceReport: getUserClassCompletionAdvanceReport,
      getUserClassCompletionGraphReport: getUserClassCompletionGraphReport,
      getSearchUserGroup: getSearchUserGroup,
      //harshil
      getComprehensiveReportCSV: getComprehensiveReportCSV,
      getTabularReportCSV: getTabularReportCSV,
      getUserReport: getUserReport,
    },
    surveyReport: {
      getSurveyReport: getSurveyReport,
      getClassesWithSurvey: getClassesWithSurvey,
    },
    quizReport: {
      getQuizReport: getQuizReport,
      getDrillDownQuizReport: getDrillDownQuizReport,
      getUserResponseToQuestion: getUserResponseToQuestion,
    },
    accessReport: {
      getAccessReport: getAccessReport,
      getApplicationAccessUserDetails: getApplicationAccessUserDetails,
      getAccessReportCSV: getAccessReportCSV,
      getAccessDetailedReportCSV: getAccessDetailedReportCSV,
      getAADApplicationReport: getAADApplicationReport,
      getAADUserAccessDetailsReport: getAADUserAccessDetailsReport,
      getAADUserAccessDetailReportCSV: getAADUserAccessDetailReportCSV,
      getAADApplicationReportCSV: getAADApplicationReportCSV,
    },
    adoptionReport: {
      getClassWiseUsageDeatils: getClassWiseUsageDeatils,
      getMobileAppInstallationCount: getMobileAppInstallationCount,
      getMobileInstallationTrend: getMobileInstallationTrend,
      getTotalActiveUser: getTotalActiveUser,
      getUserGroupAccessDetails: getUserGroupAccessDetails,
      getNoOfUserAccessedShotclassApplication:
        getNoOfUserAccessedShotclassApplication,
      getUserGroupClassUsageDetails: getUserGroupClassUsageDetails,
      getShotclassCompletionTrend: getShotclassCompletionTrend,
      getNoOfUserAccessedShotclassess: getNoOfUserAccessedShotclassess,
    },
    analyticalReport: {
      getDefaultShotClassInformation: getDefaultShotClassInformation,
    },
  },
  social: {
    getAllPolls: getAllPolls,
    getMyPolls: getMyPolls,
    postImage: postImage,
    postPoll: postPoll,
    getPollById: getPollById,
    isPollExist: isPollExist,
    editPoll: editPoll,
    deletePoll: deletePoll,
    lockPoll: lockPoll,
    unlockPoll: unlockPoll,
    copyPoll: copyPoll,
    distributePoll: distributePoll,
    pollResult: pollResult,
    pollResultByGroupId: PollResultByGroupId,
    getTenantPollUsers: getTenantPollUsers,
    getPollUserGroup: getPollUserGroup,
    getSearchPollUser: getSearchPollUser,
    getSearchPollGroup: getSearchPollGroup,
    pollDownloadResult: pollDownloadResult,
    forumArea: {
      getForumTopics: getForumTopics,
      getForumThreads: getForumThreads,
      getForumComments: getForumComments,
      createForumTopic: createForumTopic,
      editForumTopic: editForumTopic,
      updateForumTopic: updateForumTopic,
      createForumThread: createForumThread,
      updateForumThread: updateForumThread,
      createForumComment: createForumComment,
      updateDorumComment: updateDorumComment,
    },
    moderateContributions: {
      getSubmissionsData: getSubmissionsData,
      getMyModerationData: getMyModerationData,
      getLockByOthersData: getLockByOthersData,
      getRejectedData: getRejectedData,
      getPublishedData: getPublishedData,
      getPublishedByOthersData: getPublishedByOthersData,
      getShotclassSourcingClassDetailsById:
        getShotclassSourcingClassDetailsById,
      getModeratorContributorComments: getModeratorContributorComments,
      postContributorModeratorComments: postContributorModeratorComments,
      lockContributorShotClass: lockContributorShotClass,
      unLockContributorShotClass: unLockContributorShotClass,
      rejectShotClass: rejectShotClass,
      updateShotClassSourcing: updateShotClassSourcing,
    },
  },
};

export default apis;
